<template>
  <div class="sub-tabs">
    <button
      :class="['sub-tab-btn', { active: activeTab === 'produtos' }]"
      @click="$emit('change', 'produtos')"
    >
      <span class="material-icons-outlined">egg</span> Produtos
    </button>
    <button
      :class="['sub-tab-btn', { active: activeTab === 'estoque' }]"
      @click="$emit('change', 'estoque')"
    >
      <span class="material-icons-outlined">inventory_2</span> Matéria Prima
    </button>
  </div>
</template>

<script>
export default {
  name: 'EstoqueTabs',
  props: ['activeTab']
};
</script>

<style scoped>
.sub-tabs { display: flex; gap: 10px; margin-bottom: 20px; border-bottom: 1px solid var(--border-light); padding-bottom: 10px; overflow-x: auto; }
.sub-tab-btn { background: transparent; border: 1px solid transparent; color: var(--text-secondary); font-weight: 600; font-size: 0.95rem; padding: 8px 16px; cursor: pointer; border-radius: 8px; display: flex; align-items: center; gap: 8px; transition: all 0.2s; white-space: nowrap; }
.sub-tab-btn:hover { background-color: var(--bg-icon-hover-light); color: var(--text-main); }
.sub-tab-btn.active { background-color: var(--bg-card); color: var(--color-accent); border-color: var(--border-light); box-shadow: 0 2px 5px rgba(0,0,0,0.05); }
</style>